import React from 'react';
import { Smartphone, Laptop, Tablet, ShoppingBag } from 'lucide-react';
import { services } from '../mockData';
import { Card, CardContent } from '../components/ui/card';

const Services = () => {
  const iconMap = {
    Mobiltelefon: Smartphone,
    'PC & Laptop': Laptop,
    Nettbrett: Tablet,
    Tilbehør: ShoppingBag
  };

  return (
    <div className="min-h-screen pt-32 pb-16">
      {/* Hero */}
      <section className="bg-gradient-to-br from-sky-50 to-cyan-50 py-16 mb-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Våre <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">Tjenester</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Vi tilbyr profesjonell reparasjon og service for alle typer enheter
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <div className="container mx-auto px-4">
        <div className="space-y-16">
          {services.map((service, index) => {
            const Icon = iconMap[service.category];
            const isEven = index % 2 === 0;

            return (
              <div key={service.id} className={`grid md:grid-cols-2 gap-12 items-center ${!isEven ? 'md:flex-row-reverse' : ''}`}>
                {/* Image */}
                <div className={`${!isEven ? 'md:order-2' : ''}`}>
                  <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl group">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                        {Icon && <Icon size={20} className="text-sky-600" />}
                        <span className="font-semibold text-gray-900">{service.category}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className={`${!isEven ? 'md:order-1' : ''}`}>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6">
                    {service.description}
                  </p>

                  <div className="space-y-3">
                    <h3 className="font-semibold text-gray-900 text-lg mb-4">
                      {service.repairs ? 'Reparasjoner vi utfører:' : 'Produkter vi tilbyr:'}
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {(service.repairs || service.items).map((item, idx) => (
                        <div key={idx} className="flex items-center gap-2 bg-gradient-to-br from-gray-50 to-white p-3 rounded-lg border border-gray-200 hover:border-sky-300 hover:shadow-md transition-all">
                          <div className="w-2 h-2 bg-gradient-to-r from-sky-600 to-cyan-600 rounded-full"></div>
                          <span className="text-gray-700">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Additional Info Section */}
      <section className="container mx-auto px-4 mt-20">
        <Card className="bg-gradient-to-br from-sky-50 to-cyan-50 border-2 border-sky-100">
          <CardContent className="p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Ikke sikker på hva du trenger?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Våre eksperter er her for å hjelpe deg. Kom innom eller ta kontakt for en gratis konsultasjon!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:94076761"
                className="inline-flex items-center justify-center bg-gradient-to-r from-sky-600 to-cyan-600 hover:from-sky-700 hover:to-cyan-700 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all"
              >
                Ring oss: 94076761
              </a>
              <a
                href="/kontakt"
                className="inline-flex items-center justify-center border-2 border-sky-600 text-sky-600 hover:bg-sky-50 px-8 py-3 rounded-xl font-semibold transition-all"
              >
                Kontaktskjema
              </a>
            </div>
          </CardContent>
        </Card>
      </section>
    </div>
  );
};

export default Services;
